import React, { Fragment } from 'react'
import G from '../../../../../../../util/globalFunction'
import TF from '../../../../../../../util/tremFunction'
import Cookies from 'js-cookie'

export default props => {
    const { dataStore, handleChangeData } = props
    let { paramData, reservData } = dataStore || {}
    paramData = paramData || {}
    let { mroOptSubList, mroSubList } = reservData || {}
    mroOptSubList = mroOptSubList || []
    mroSubList = mroSubList || []

    const currentLang = Cookies.get('__floor_lang__') || 'ko'

    return (
        <Fragment>
            {/*부가서비스*/}
            <div className="s2_sm_box">
                <h5 className="tt_type3">{G.t('trem.lang.home.0096')}</h5>{/* 부가서비스 */}
                <ul>
                    {mroOptSubList.length > 0 ? (
                        <Fragment>
                            {mroOptSubList.map((obj, index) => {
                                return (
                                    <li className="material_box" key={index}>
                                        <div>
                                            <p>
                                                {obj.MRO_KOR}
                                                <a title="새창" href="javascript:void(0);" className="btn_help2" onClick={ () => { TF.goHelp("/hm/manual/equipReservation/detail/use")}}>도움말</a>
                                            </p>
                                            <dl>
                                                <dt>{G.t('trem.lang.home.0100')}</dt>{/* 단가 */}
                                                <dd>
                                                    {obj.SALES_COST.toLocaleString()}
                                                    <span>{obj.UOM}</span>
                                                </dd>
                                                <dt className={currentLang === 'ko' ? "" : "material_en"}><label htmlFor={`OPT_MRO_LIST[${index}].QUENTITY`}>{G.t('trem.lang.home.0101')}</label></dt>{/* 요구량 */}
                                                <dd>
                                                    <input
                                                        title="요구량 입력"
                                                        type="number"
                                                        className="OPT_MRO_LIST"
                                                        id={`OPT_MRO_LIST[${index}].QUENTITY`}
                                                        name={`OPT_MRO_LIST[${index}].QUENTITY`}
                                                        min="0"
                                                        value={paramData.OPT_MRO_LIST[index].QUENTITY}
                                                        onChange={e => handleChangeData(e, index)}
                                                    />
                                                </dd>
                                                <dt>{G.t('trem.lang.home.0102')}</dt>{/* 금액 */}
                                                <dd>
                                                    {(
                                                        obj.SALES_COST *
                                                        paramData.OPT_MRO_LIST[index].QUENTITY
                                                    ).toLocaleString()}
                                                </dd>
                                            </dl>
                                        </div>
                                    </li>
                                )
                            })}
                        </Fragment>
                    ) : (
                        <li className="empty">
                            <div>
                                <span>* {G.t('trem.lang.home.0097')}</span>{/* * 부가서비스가 없습니다. */}
                            </div>
                        </li>
                    )}
                </ul>
            </div>

            {/*실험재료*/}
            <div className="s2_sm_box">
                <h5 className="tt_type3">{G.t('trem.lang.home.0098')}</h5>{/* 실험재료 */}
                <ul>
                    {mroSubList.length > 0 ? (
                        <Fragment>
                            {mroSubList.map((obj, index) => {
                                return (
                                    <li className="material_box" key={index}>
                                        <div>
                                            <p>
                                                {obj.MRO_KOR}
                                                <a title="새창" href="javascript:void(0);" className="btn_help2" onClick={ () => { TF.goHelp("/hm/manual/equipReservation/detail/use")}}>도움말</a>
                                            </p>
                                            <dl>
                                                <dt>{G.t('trem.lang.home.0100')}</dt>{/* 단가 */}
                                                <dd>
                                                    {obj.SALES_COST.toLocaleString()}
                                                    <span>{obj.UOM}</span>
                                                </dd>
                                                <dt className={currentLang === 'ko' ? "" : "material_en"}><label htmlFor={`MRO_LIST[${index}].QUENTITY`}>{G.t('trem.lang.home.0101')}</label></dt>{/* 요구량 */}
                                                <dd>
                                                    <input
                                                        title="요구량 입력"
                                                        type="number"
                                                        className="MRO_LIST"
                                                        id={`MRO_LIST[${index}].QUENTITY`}
                                                        name={`MRO_LIST[${index}].QUENTITY`}
                                                        min="0"
                                                        value={paramData.MRO_LIST[index].QUENTITY}
                                                        onChange={e => handleChangeData(e, index)}
                                                    />
                                                </dd>
                                                <dt>{G.t('trem.lang.home.0102')}</dt>{/* 금액 */}
                                                <dd>
                                                    {(
                                                        obj.SALES_COST *
                                                        paramData.MRO_LIST[index].QUENTITY
                                                    ).toLocaleString()}
                                                </dd>
                                            </dl>
                                        </div>
                                    </li>
                                )
                            })}
                        </Fragment>
                    ) : (
                        <li className="empty">
                            <div>
                                <span>* {G.t('trem.lang.home.0099')}</span>{/* * 실험재료가 없습니다. */}
                            </div>
                        </li>
                    )}
                </ul>
            </div>
        </Fragment>
    )
}
